import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';

import FindPlayersTable from '../components/Tables/FindPlayersTable';
import FindPlayersInput from '../components/FindPlayers/FindPlayersInput';
import { Container, Button, Paper } from '@mui/material';
import NavContainer from '../components/Navigation/NavContainer';
import {getAll, selectStatus, selectAllPlayers} from '../state/reducers/FindPlayersReducer';
import { LightPlayer } from '../types/types';
import _ from 'underscore';
import Loading from '../components/Loading';
import Header from '../components/Header/Header';
import AdsenseAdd from '../components/AdsenseAdd';

import { useNavigate } from 'react-router-dom';
import { RegisterPageView } from '../globals/Analytics';

const FilterPlayers = (fields:string[],values:(string|number)[],players:LightPlayer) => {
    const newplayers:(LightPlayer)[] = _.filter(players,function(player) {
        let include = true;
        fields.map(function(field,index) {
            if (values[index] !== "*") {
                if (player[field] !== values[index]) {
                    include = false;
                }
            }
        });
        return include
    });
}

const FindPlayers = () => {
    const dispatch = useAppDispatch();
    const router = useNavigate();
    const loading = useAppSelector(selectStatus);
    const allplayers = useAppSelector(selectAllPlayers);
    const [ players, setPlayers ] = useState(allplayers.slice());
    const [ position, SetPosition ] = useState("*");
    
    RegisterPageView({path:'/findplayers'});
    useEffect(() => {
        ResetPlayers();
    },[allplayers,loading]);

    useEffect(() => {
        dispatch(getAll());
    },[]);

    function ResetPlayers() {
        setPlayers(allplayers.slice())
    }

    return(<Container maxWidth="xl" style={{marginBottom: '2rem',marginLeft: "auto", marginRight: "auto"}}>
        <NavContainer />
        <Header />
        <Paper elevation={5} style={{padding: '0.5rem'}}>
        <FindPlayersInput players={allplayers} setPlayers={setPlayers} resetPlayers={ResetPlayers} />
        { loading==="loading" ? 
            <Loading />
            : <>
        <FindPlayersTable players={players} />
        </> }
        <Button 
        sx={{width: "100%", marginTop: "0.5rem"}}
            onClick={e => router("/compareplayers")}
            variant="contained"
            color="primary">
                Compare
            </Button>
        </Paper>
        <AdsenseAdd />

    </Container>
        );
}

export default FindPlayers;